import React, { useCallback } from 'react';

import { useStore, useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';

import CloseImage from '../../../../assets/media/tournament/close.svg';

interface TournamentHasClaimModalProps {

}

export const TournamentHasClaimModal: React.FC<TournamentHasClaimModalProps> = () => {

  const { tournamentStore } = useStore();

  const t = useTranslation();

  const onClose = useCallback(() => {
    tournamentStore.setTournamentHasClaimModalOpen(false);
  }, []);

  const onSeeDetailsClick = useCallback(() => {
    onClose();
    tournamentStore.openTournamentFrame(null, true);
  }, [onClose]);

  return (
    <div className="tournament-claim-popup" id="hasClaimPopup">
      <div className="tournament-claim-popup-wrapper">
        <div className="tournament-claim-popup-closer" role="button" onClick={onClose}>
          <img className="close-img" src={CloseImage} alt="Close" />
        </div>
        <div className="tournament-claim-popup-top-img"></div>
        <div className="tournament-claim-popup-wrapper-inner">
          <h2 className="tournament-claim-popup-title">
            {t(T.CONGRATULATIONS)}
          </h2>
          <p className="tournament-claim-popup-info">
            {t(T.YOU_HAVE_WON_IN_A_TOURNAMENT)}
          </p>
          <div className="tournament-claim-popup-btn-wrapper">
            <button type="button" className="see-details-btn" onClick={onSeeDetailsClick}>
              {t(T.SEE_DETAILS)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
